import { lazy } from 'react';

export { Contracts } from './contracts';

export const LazyContracts = lazy(() => import('./contracts').then((mod) => ({ default: mod.Contracts })));
